var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "credit_card_svg__a",
    width: 17,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .001h17v17H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#credit_card_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M15.232 4.469v8.064q0 .536-.372.909-.371.371-.909.371H3.054q-.536 0-.909-.371a1.24 1.24 0 0 1-.372-.909V4.469q0-.536.372-.909.372-.372.909-.372H13.95q.537 0 .909.372t.372.909M2.836 5.954h11.333V4.469a.2.2 0 0 0-.068-.15.2.2 0 0 0-.15-.068H3.054a.2.2 0 0 0-.15.068.2.2 0 0 0-.068.15zm0 2.26v4.319q0 .082.068.15a.2.2 0 0 0 .15.068H13.95a.2.2 0 0 0 .15-.068.2.2 0 0 0 .068-.15V8.215z"
  }))));
};
export default SvgCreditCard;